import { useQuery } from "@tanstack/react-query";
import { PublicMeditationsAPI } from "../infrastructure/api/PublicMeditations.api";

const QUERY_KEY = "alchely-public-meditations";

export const usePublicMeditations = () =>
    useQuery({
        queryKey: [QUERY_KEY],
        queryFn: PublicMeditationsAPI.list,
        staleTime: 1000 * 60 * 10, // 10 min — curated content changes rarely
    });

export const usePublicMeditation = (id: string) =>
    useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: () => PublicMeditationsAPI.get(id),
        enabled: !!id,
        staleTime: 1000 * 60 * 10,
    });
